export const galleryData = ["01.jpg", "02.jpg", "03.jpg", "04.jpg", "05.jpg", "06.jpg", "07.jpg", "08.jpg", "09.jpg", "010.jpg", "011.jpg", "012.jpg"];

export const masonryImageData = [
  {
    id: 1,
    src: "1.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 2,
    src: "2.jpg",
    width: 1,
    height: 1,
  },
  {
    id: 3,
    src: "3.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 4,
    src: "4.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 5,
    src: "5.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 6,
    src: "6.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 7,
    src: "7.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 8,
    src: "8.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 9,
    src: "9.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 10,
    src: "10.jpg",
    width: 3,
    height: 4,
  },
  {
    id: 11,
    src: "11.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 12,
    src: "12.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 13,
    src: "13.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 14,
    src: "14.jpg",
    width: 4,
    height: 3,
  },
  {
    id: 15,
    src: "15.jpg",
    width: 4,
    height: 3,
  },
];

export const hoverImageData = ["08.jpg", "09.jpg", "010.jpg", "011.jpg"];
